export const SentryConstants = {
  SentryPublicKey: "1567fdcb62484416af832d3fab530329",
  SentryProjectId: "1810853" 
}